import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinStrings',
    standalone: false
})
export class JoinStringsPipe implements PipeTransform {

  transform(value: string | string[], separator: string = '', additionalValues?: string | string[], switchOrder: boolean = false): string | null {
    if(!value) return null;
    const arrValues = Array.isArray(value)? value : [value];
    const extraArrValues = Array.isArray(additionalValues)? additionalValues : additionalValues? [additionalValues]: [];
    const returnArray = switchOrder? arrValues.concat(extraArrValues) : extraArrValues.concat(arrValues);
    return returnArray.join(separator);
  }

}
